/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferTotalsResponse } from '../../models/offer-totals-response';

export interface GetOfferTotalAmounts$Params {
  id: number;
}

export function getOfferTotalAmounts(http: HttpClient, rootUrl: string, params: GetOfferTotalAmounts$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferTotalsResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferTotalAmounts.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferTotalsResponse>;
    })
  );
}

getOfferTotalAmounts.PATH = '/offers/{id}/totals';
